import React from 'react'
import { buildMediaUrl } from '../utils/buildMediaUrl'

// Memoized cover image component
const CoverImage = React.memo(
  ({ currentTrack, API_URL, onClick, className }) => {
    if (!currentTrack) {
      return <div className={className} onClick={onClick} />
    }

    // console.log('CoverImage render - onClick:', typeof onClick)
    return (
      <div className={`${className}`} onClick={onClick}>
        <img
          src={buildMediaUrl(currentTrack, API_URL, 'cover')}
          alt="Now playing"
          onError={(e) => {
            e.target.onError = null
            e.target.style.display = 'none'
            const musicIcon = document.createElement('div')
            musicIcon.innerHTML = '<FaMusic size={40} />'
            e.target.parentNode.appendChild(musicIcon)
          }}
        />
      </div>
    )
  },
)

export default CoverImage
